import { RootState } from 'reducers';

export const getModalType = (state: RootState) => state.modalReducer.type;
export const getModalProps = (state: RootState) => state.modalReducer.props;
